export enum EmailTemplateTypeEnum {
  INVITE_USER = "Invite user",
  FORGOT_PASSWORD = "Forgot password",
  NEW_ASSIGNMENT = "New assignment",
  USER_REMINDER = "User reminder",
  MANAGER_REMINDER = "Manager reminder",
  CUSTOM = "Custom",
  FILEHUB_SUBSCRIPTION = "FileHub subscription",
}

export interface EmailTemplateQueryParams {
  name?: string;
  short?: boolean;
  orderBy?: string;
  sort?: string;
  limit?: number;
  offset?: number;
}

export interface EmailTemplateShortResult {
  emailTemplateId: string;
  name: string;
}

export interface EmailTemplateResult {
  portalId: string;
  emailTemplateId: string;
  emailTemplateUid?: string;
  name: string;
  subject: string;
  sender: string;
  message?: string;
  type: EmailTemplateTypeEnum;
  isReminder?: boolean;
  startOffsetDays?: number;
  frequencyInterval?: number;
  frequencyUnit?: FrequencyUnitEnum;
}

export enum FrequencyUnitEnum {
  DAYS = "Days",
  WEEKS = "Weeks",
  MONTHS = "Months",
  YEARS = "Years",
}

export interface EmailTemplatesPaginatedResult {
  count: number;
  previousPage: string;
  nextPage: string;
  rows: EmailTemplateResult[];
}

export interface EmailTemplateTypeResult {
  emailTemplateTypeUid: string;
  name: EmailTemplateTypeEnum;
  isReminder: boolean;
  isAuthFlow: boolean;
  isManual: boolean;
  method?: string;
  isFileHubUpload: boolean;
  isUnique: boolean;
}

export interface EmailTemplateTypeQueryParams {
  portalId?: string;
  emailTemplateType?: EmailTemplateTypeEnum;
  onlyManual?: string;
}

export interface EmailTemplateRemoveBodyParams {
  emailTemplateIds: string[];
  adminUser: string;
}

export interface EmailTemplateBodyParams {
  emailTemplateId?: string;
  emailTemplateTypeUid?: string;
  subject?: string;
  message?: string;
  name?: string;
  sender?: string;
  startOffsetDays?: number;
  frequencyInterval?: number;
  frequencyUnit?: FrequencyUnitEnum;
}

export interface SendEmailUser {
  userPortalUid: string;
  firstname: string;
  lastname: string;
  email: string;
}

export interface SendToQueueBodyParams {
  users: SendEmailUser[];
  emailTemplateUid?: string;
  subject?: string;
  sender?: string;
  replyTo?: string;
  messageHtml?: string;
  timestamp?: string;
  adminUser: string;
}

export type SendEmailBody = SendToQueueBodyParams;
